import React from "react";

import { serverUrl } from "../../config";
import GridItem from "../../partials/gridItem";
import { useNavigate } from "react-router-dom";

export default function PodcastItem(props) {
  const navigate = useNavigate();

  if (props.creator) {
    return (
      <>
        <GridItem
          xs={12}
          sm={6}
          md={3}
          itemClass="podcast-creator"
          item={props.item}
          bundle={props.item?.bundle}
          id={props.item?.nid}
          title={props.item?.title}
          field_body={props.item?.summary || props.item?.body}
          category_label={props.item.category_labels}
          created={props.item?.created}
          hasImg={true}
          imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
          alt={`Poster for Podcast ${props.item.id}`}
          cardActionArea={true}
          creator={props.creator}
          cardActionCallBack={
            props.creator
              ? () => {}
              : () => navigate(`/podcasts/view/${props.item?.nid}`)
          }
          contentType={props.contentType}
          shareEnabled
          route={"podcasts"}
          field_access_token={props.item.access_token}
          sharePrompt={`This is a public link that enables you to share the podcast with your client, no login required.`}
        ></GridItem>
      </>
    );
  } else {
    return (
      <GridItem
        xs={12}
        sm={6}
        md={3}
        itemClass="podcast"
        item={props.item}
        bundle={props.item?.bundle}
        id={props.item?.nid}
        title={props.item?.title}
        field_body={props.item?.summary || props.item?.body}
        category_label={props.item.category_labels}
        created={props.item?.created}
        hasImg={true}
        imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
        cardActionArea={true}
        creator={props.creator}
        cardActionCallBack={() => navigate(`/podcasts/view/${props.item?.nid}`)}
        contentType={props.contentType}
        shareEnabled
        route={"podcasts"}
        field_access_token={props.item.field_access_token}
        sharePrompt={`This is a public link that enables you to share the podcast with your client, no login required.`}
      ></GridItem>
    );
  }
}
